import { render, staticRenderFns } from "./AcademyListPanel.vue?vue&type=template&id=35188286&scoped=true&lang=pug&"
import script from "./AcademyListPanel.vue?vue&type=script&lang=ts&"
export * from "./AcademyListPanel.vue?vue&type=script&lang=ts&"
import style0 from "./AcademyListPanel.vue?vue&type=style&index=0&id=35188286&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35188286",
  null
  
)

export default component.exports